import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The data warehouse can link to data in Cloudflare R2. To start, you'll need to:`}</p>
    <ol>
      <li parentName="ol">{`Create a bucket in R2`}</li>
      <li parentName="ol">{`Set up an access key and secret`}</li>
      <li parentName="ol">{`Add data to the bucket`}</li>
      <li parentName="ol">{`Create the table in PostHog`}</li>
    </ol>
    <h2 {...{
      "id": "step-1-creating-a-bucket-in-r2"
    }}>{`Step 1: Creating a bucket in R2`}</h2>
    <ol>
      <li parentName="ol">{`Log in to the `}<a parentName="li" {...{
          "href": "https://dash.cloudflare.com/"
        }}>{`Cloudflare dashboard`}</a>{`.`}</li>
      <li parentName="ol">{`Go to the R2 overview and create a new bucket. We suggest using `}<strong parentName="li">{`Eastern North America`}</strong>{` as a location hint if you're using PostHog Cloud US or `}<strong parentName="li">{`European Union`}</strong>{` as a specific jurisdiction if you're using PostHog Cloud EU.`}</li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_07_16_at_10_06_02_2x_152e3c2309.png",
        "alt": "created bucket"
      }}></img></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`In your bucket, upload the data you want to query such as `}<a parentName="li" {...{
          "href": "/tutorials/csv-query"
        }}>{`CSV`}</a>{` or Parquet data. It can be as simple as a `}<inlineCode parentName="li">{`.csv`}</inlineCode>{` file like this:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-csv"
      }}>{`id,name,email
1,John Doe,john@example.com
2,Jane Doe,jane@example.com
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Adding data to R2 automatically:`}</strong>{` See our `}<a parentName="p" {...{
          "href": "/docs/data-warehouse/setup/s3#step-3-add-data-to-the-bucket"
        }}>{`S3 docs`}</a>{` for how to set up Airbyte to automatically add data to the bucket. You can also use other ETL tools like Fivetran or Stitch.`}</p>
    </blockquote>
    <h2 {...{
      "id": "step-2-create-api-tokens"
    }}>{`Step 2: Create API tokens`}</h2>
    <ol>
      <li parentName="ol">{`Head back to the R2 overview and under account details, click `}<strong parentName="li">{`Manage R2 API Tokens`}</strong></li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Create API token`}</strong>{`, give your token a name, choose `}<strong parentName="li">{`Object Read only`}</strong>{` as the permission type, apply it to your bucket, and click `}<strong parentName="li">{`Create API Token`}</strong></li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_07_16_at_10_20_43_2x_97c29591fb.png",
        "alt": "Create token"
      }}></img></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Copy the credentials for S3 clients, including the `}<strong parentName="li">{`Access Key ID`}</strong>{`, `}<strong parentName="li">{`Secret Access Key`}</strong>{`, and jurisdiction-specific endpoint URL. These will not be shown again, so make sure to copy them to a safe place.`}</li>
    </ol>
    <h2 {...{
      "id": "step-3-create-the-table-in-posthog"
    }}>{`Step 3: Create the table in PostHog`}</h2>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and under self managed, look for `}<strong parentName="li">{`Cloudflare R2`}</strong>{` and click `}<strong parentName="li">{`Link`}</strong></li>
      <li parentName="ol">{`Fill the table name, then use the data from Cloudflare: `}
        <ul parentName="li">
          <li parentName="ul">{`For files URL pattern, use the jurisdiction-specific endpoint URL with your bucket name and file name like `}<inlineCode parentName="li">{`https://b27247d543c.r2.cloudflarestorage.com/posthog-warehouse/cool_data.csv`}</inlineCode>{`. You can also use `}<inlineCode parentName="li">{`*`}</inlineCode>{` to query multiple files.`}</li>
          <li parentName="ul">{`Choose the correct file format`}</li>
          <li parentName="ul">{`For access key, use your Access Key ID`}</li>
          <li parentName="ul">{`For secret key, use your Secret Access Key`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong></li>
    </ol>
    <p><img parentName="p" {...{
        "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_07_16_at_10_53_02_2x_0dc05b1af5.png",
        "alt": "Linking source"
      }}></img></p>
    <h2 {...{
      "id": "step-4-query-the-table"
    }}>{`Step 4: Query the table`}</h2>
    <p>{`Once it is done syncing, you can now `}<a parentName="p" {...{
        "href": "/docs/data-warehouse/query"
      }}>{`query`}</a>{` your new table using the table name.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      